export const BILLING_PLANS = [
  { purchaseType: "consumer_content", billingInterval: "month", name: "Individual", amount: 500,
    description: "All web content for personal use." },
  { purchaseType: "consumer_content", billingInterval: "year", name: "Individual", amount: 2000,
    description: "All web content for personal use." },
  { purchaseType: "classroom_license", billingInterval: "year", name: "Classroom", amount: 20000,
    description: "Web content, educator analytics, and web student join codes." },
  { purchaseType: "site_license", billingInterval: "year", name: "Site license", amount: 120000,
    description: "Unlimited web and VR access for your site, educator analytics, and student join codes." },
];

// Display copy only. Checkout availability and prices come from the account API.
export const PLAN_COMPARISON = [
  {
    purchaseType: "consumer_content", name: "Individual", description: "Explore science on your own.",
    features: [
      "Full web content library",
    ],
  },
  {
    purchaseType: "classroom_license", name: "Classroom", description: "Teach and share experiences across your classes.",
    features: [
      "Full web content library",
      "Educator analytics",
      "Student join codes for the web",
      "Create Guides (beta)",
    ],
  },
  {
    purchaseType: "site_license", name: "Site license", description: "Unlimited web and VR for your entire site.",
    features: [
      "Unlimited VR access across your site",
      "Full web content library",
      "Educator analytics",
      "Student join codes for web and VR",
      "Create Guides (beta)",
    ],
  },
];

export const formatPlanPrice = (amount, billingInterval, currency = "usd") =>
  `${new Intl.NumberFormat("en-US", { style: "currency", currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount / 100)} / ${billingInterval}`;

export const getAccountPlanName = ({ subscriptionPurchaseType, roleName, subscriptionStatus }) => {
  if (subscriptionStatus === "trial") return "Educator trial";
  if (subscriptionStatus === "free" || !subscriptionStatus) return "Free account";
  if (subscriptionPurchaseType === "site_license" || String(roleName).toLowerCase() === "educatorsite") return "Site license";
  if (subscriptionPurchaseType === "classroom_license" || String(roleName).toLowerCase() === "educator") return "Classroom";
  if (subscriptionPurchaseType === "consumer_content" || String(roleName).toLowerCase() === "consumer") return "Individual";
  return "10k Science access";
};

// Older classroom checkouts did not include product or interval metadata.
export const matchesPurchasedPlan = (subscription, purchaseType, billingInterval) =>
  (subscription?.purchaseType || "classroom_license") === purchaseType &&
  (subscription?.billingInterval || "year") === billingInterval;
